<template>
  <table-views
    v-bind="$attrs"
    headline
    :title="title"
    :active-view-id="activeViewId"
    @load-view="$emit('load-view', $event)"
    @update:active-view-id="$emit('update:activeViewId', $event)"
  />
</template>

<script>
import TableViews from 'components/UI/TableViews';

export default {
  name: 'RecordsViewTitle',

  components: { TableViews },

  /*
   * TableViews takes a wide prop list — context, columns, filters, pagination and the rest — and
   * this component adds nothing to it, so the whole set is forwarded rather than restated. Only the
   * active view is declared, because the title is what it names.
   */
  inheritAttrs: false,

  props: {
    /**
     * The collection's own name, shown until a saved view is loaded. It is what the page would
     * otherwise have put in its title.
     */
    title: {
      type: String,
      required: true,
    },
    /** Id of the saved view currently loaded, or null for the collection's default. */
    activeViewId: {
      type: String,
      default: null,
    },
  },

  emits: ['load-view', 'update:activeViewId'],
};
</script>
